module.exports = __webpack_public_path__ + "static/images/enter-game-bg3.92f277d.png";